var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStreamlineNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_3966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 30V38.5714M20.0001 30C23.7889 30 27.4225 28.4949 30.1016 25.8158C32.7807 23.1367 34.2858 19.5031 34.2858 15.7143M20.0001 30C16.2113 30 12.5776 28.4949 9.89854 25.8158C7.21945 23.1367 5.71436 19.5031 5.71436 15.7143M5.71436 38.5714H34.2858M34.2858 15.7143C34.2858 11.9255 32.7807 8.29187 30.1016 5.61278C27.4225 2.93369 23.7889 1.42859 20.0001 1.42859C16.2113 1.42859 12.5776 2.93369 9.89854 5.61278C7.21945 8.29187 5.71436 11.9255 5.71436 15.7143M34.2858 15.7143H5.71436",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 30C28.5716 20.2286 28.5716 10.6857 20.0002 1.42859C11.6002 10.3429 11.4288 19.8286 20.0002 30Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_3966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineNetwork);
export default __webpack_public_path__ + "static/media/streamline_network.e5cd09ec1905b09eb4a0701bfd8ea552.svg";
export { ForwardRef as ReactComponent };